import * as React from 'react';
import {useEffect,useState} from 'react';
import { useNavigate } from "react-router-dom";

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'

import AuthService from '../service/auth'
import AdminAccountService from '../service/AdminAccount'
import AccountRequestService from '../service/AccountRequest';

import TestService from '../service/Test';
import FoodService from '../service/Food';
import ClientFoodLogService from '../service/ClientFoodLog';

const Test = () => {
		
	const navigate = useNavigate();
	
	const [currentUser,setCurrentUser]=useState({});
	
	const [adminAccountData,setAdminAccountData]=useState([]);
	const [accountRequestsData,setAccountRequestsData]=useState([]);
	
	useEffect(()=> {
		
		if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
		  		/*AdminAccountService.getAll().then(function(res){
					setAdminAccountData(res.data);
					console.log(res.data);
				});
				
				AccountRequestService.getByFilter({'type':'Master'}).then(function(res){
					setAccountRequestsData(res.data);
					console.log(res.data);
				});
				
				console.log(TestService.test())*/

				FoodService.getTranslations().then(function(res){
					console.log(res.data);
				}).catch(function(error){
					console.log(error);
				});
				
				ClientFoodLogService.getAll().then(function(res){
					console.log(res.data);
					let _foodLogs= res.data;
					let recipes=0;
					let foods=0;
					for(let i=0;i<_foodLogs.length;i++){
						let _fl=_foodLogs[i];
						if(_fl.food_or_recipe=='food'){
							
							foods++;
						}else{
							recipes++;
							console.log(_fl);
						}
					}
					console.log('f: ',foods,'r: ',recipes);
				}).catch(function(error){
					console.log(error);
				});
		}
		
	},[])
	
  return( 
	<>
	<TopPrivateNavigation/>
	{/*	<TopPrivateNavigation/>
	<h1>Admin Accounts ({adminAccountData.length})</h1>

	<table style={{width: "80%"}}>
		<thead>
		  <tr>
			<th>FirstName</th>
			<th>LastName</th>
			<th>Email</th>
		  </tr>
	  </thead>
	  	<tbody>
	{adminAccountData.map((data)=>(
	
	  <tr key={data.id}>
		<td>{data.first_name}</td>
		<td>{data.last_name}</td>
		<td>{data.email}</td>
	  </tr>

	))}
	</tbody>
	</table>
	
	<h1>Master Account requests ({accountRequestsData.length})</h1>

	<table style={{width: "80%"}}>
		<thead>
		  <tr>
		  <th>Email</th>
			<th>FirstName</th>
			<th>LastName</th>
			<th>Phone Number</th>
			<th>Organisation/Affiliation</th>
			<th>Request Message</th>
		  </tr>
	  </thead>
	  	<tbody>
	{accountRequestsData.map((data)=>(
	
	  <tr key={data.id}>
	  	<td>{data.email}</td>
		<td>{data.first_name}</td>
		<td>{data.last_name}</td>
		<td>{data.phone_number}</td>
		<td>{data.organisation}</td>
		<td>{data.request_text}</td>
	  </tr>

	))}
	</tbody>
</table>*/}
</>
 ); 

};

export default Test;
